import { render } from "./DayRegistrationEditor.vue?vue&type=template&id=3b786df4&scoped=true"
import script from "./DayRegistrationEditor.vue?vue&type=script&lang=js"
export * from "./DayRegistrationEditor.vue?vue&type=script&lang=js"

import "./DayRegistrationEditor.vue?vue&type=style&index=0&id=3b786df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b786df4"]])

export default __exports__